var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTbd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.338,
    height: 21.372,
    viewBox: "0 0 20.338 21.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5710",
    "data-name": "Group 5710",
    transform: "translate(4889.301 3134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4654",
    "data-name": "Path 4654",
    d: "M315.345,288.75a.345.345,0,0,0,0,.689h2.068a.345.345,0,1,0,0-.689Z",
    transform: "translate(-5195.511 -3411.719)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4655",
    "data-name": "Path 4655",
    d: "M140.08,280a.345.345,0,0,0-.345.345v8.618A1.035,1.035,0,0,1,138.7,290h-3.792v-4.826a1.725,1.725,0,0,0-1.724-1.724h-3.447a1.725,1.725,0,0,0-1.724,1.724V290h-3.792a1.035,1.035,0,0,1-1.034-1.034v-8.618a.345.345,0,0,0-.689,0v8.618a1.725,1.725,0,0,0,1.724,1.723h4.136a.345.345,0,0,0,.345-.345v-5.171a1.035,1.035,0,0,1,1.034-1.034h3.447a1.035,1.035,0,0,1,1.034,1.034v5.171a.345.345,0,0,0,.345.345H138.7a1.725,1.725,0,0,0,1.724-1.723v-8.618a.345.345,0,0,0-.345-.345Z",
    transform: "translate(-5010.594 -3403.314)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4656",
    "data-name": "Path 4656",
    d: "M96.392,17.42,97.736,8.75h-3.2a1.029,1.029,0,0,0-.988.728l-1.551,5a2.759,2.759,0,0,0,4.4,2.938Z",
    transform: "translate(-4981.171 -3142.75)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4657",
    "data-name": "Path 4657",
    d: "M227.135,17.094a2.755,2.755,0,0,0,2.094.963h.113a2.745,2.745,0,0,0,2.069-.945V8.751h-3.26l-1.244,8.029a2.689,2.689,0,0,0,.228.314Z",
    transform: "translate(-5110.888 -3142.751)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4658",
    "data-name": "Path 4658",
    d: "M360.817,18.06h.113a2.755,2.755,0,0,0,2.094-.963,2.686,2.686,0,0,0,.228-.314l-1.245-8.029h-3.26v8.362a2.745,2.745,0,0,0,2.069.945Z",
    transform: "translate(-5237.536 -3142.752)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4659",
    "data-name": "Path 4659",
    d: "M464.955,14.478l-1.551-5a1.029,1.029,0,0,0-.988-.728h-3.2l1.344,8.671a2.759,2.759,0,0,0,4.4-2.938Z",
    transform: "translate(-5334.042 -3142.745)",
    fill: "#091b49"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbd);
export default __webpack_public_path__ + "static/media/tbd.731ded38ca48f787eacf01ab9866463e.svg";
export { ForwardRef as ReactComponent };